import { useContext } from "react";
import { AuthContext } from "@/auth/AuthContext";
import { AuthApi } from "@/auth/auth.types";

export const useAuth = (): AuthApi => useContext(AuthContext);
